<div class="col-12 pet-title-wrap">
  <h4 class="pet-section-title">{{ "shopping" | transloco }}</h4>
</div>

<div class="scroll-menu shopping-menu">
  <div class="scroll-item shopping-card" routerLink="/toprated">
    <div class="shopping-visual">
      <div class="shopping-circle"></div>
      <div class="shopping-img-wrap">
        <img src="/assets/e-commerce/icons/78.webp" alt="top rated">
      </div>
    </div>
    <p class="shopping-card-name">{{ "top rated" | transloco }}</p>
  </div>

  <div class="scroll-item shopping-card" routerLink="/dailyoffers">
    <div class="shopping-visual">
      <div class="shopping-circle"></div>
      <div class="shopping-img-wrap">
        <img src="/assets/e-commerce/icons/79.webp" alt="daily offer">
      </div>
    </div>
    <p class="shopping-card-name">{{ "daily_offer" | transloco }}</p>
  </div>

  <div class="scroll-item shopping-card" routerLink="/deals">
    <div class="shopping-visual">
      <div class="shopping-circle"></div>
      <div class="shopping-img-wrap">
        <img src="/assets/e-commerce/icons/81.webp" alt="deals">
      </div>
    </div>
    <p class="shopping-card-name">{{ "deals" | transloco }}</p>
  </div>

  <div class="scroll-item shopping-card" routerLink="/mostsales">
    <div class="shopping-visual">
      <div class="shopping-circle"></div>
      <div class="shopping-img-wrap">
        <img src="/assets/e-commerce/icons/80.webp" alt="most sales">
      </div>
    </div>
    <p class="shopping-card-name">{{ "mostSales" | transloco }}</p>
  </div>

  <div class="scroll-item shopping-card" routerLink="/topsale">
    <div class="shopping-visual">
      <div class="shopping-circle"></div>
      <div class="shopping-img-wrap">
        <img src="/assets/e-commerce/icons/82.webp" alt="hot deals">
      </div>
    </div>
    <p class="shopping-card-name">{{ "hot deals" | transloco }}</p>
  </div>
</div>